module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.who.id != _vm.user.id) ? _c('div', [(_vm.who.friendship == null) ? _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addFriend()
      }
    }
  }, [_vm._v("\n        Als " + _vm._s(_vm.friend) + " hinzufügen\n    ")]) : _vm._e(), _vm._v(" "), (_vm.who.friendship == 'pending') ? _c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unfriend()
      }
    }
  }, [_vm._v("\n        Anfrage zurückziehen\n    ")]) : _vm._e(), _vm._v(" "), (_vm.who.friendship == 'requested') ? [_c('a', {
    staticClass: "btn btn-primary btn-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.acceptFriend()
      }
    }
  }, [_vm._v("\n            Freundschaft akzeptieren\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-secondary btn-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unfriend()
      }
    }
  }, [_vm._v("\n            Ablehnen\n        ")])] : _vm._e(), _vm._v(" "), (_vm.who.friendship == 'friends') ? _c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unfriend()
      }
    }
  }, [_vm._v("\n        Entfreunden\n    ")]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a67e55f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/friendship-button.vue
// module id = 234
// module chunks = 0